// src/pages/InviteGatePage.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiGet, apiPost, bootstrapBffSession } from '../lib/apiClient';

export default function InviteGatePage() {
  const [code, setCode] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        await bootstrapBffSession();
        const s = await apiGet('/activation/status');
        if (!s.required || s.ok) {
          navigate('/', { replace: true });
          return;
        }
      } catch (_) {}
      setLoading(false);
    })();
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await bootstrapBffSession();
      await apiPost('/activation', { code: code.trim() });
      navigate('/', { replace: true });
    } catch (e2) {
      setError(e2?.msg || e2?.message || 'Invalid code');
    }
  };

  if (loading) return <div className="card">Loading…</div>;

  return (
    <div className="card" style={{ maxWidth: 480, margin: '10vh auto' }}>
      <h2>Enter Invitation Code</h2>
      <form onSubmit={submit}>
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Invitation code"
          inputMode="numeric"
          required
          className="input"
          style={{ width: '100%', padding: 8 }}
        />
        {error && <div className="error" style={{ marginTop: 8 }}>{error}</div>}
        <button className="btn" type="submit" style={{ marginTop: 12 }}>Continue</button>
      </form>
    </div>
  );
}
